import { t } from 'ember-intl';
import NavTabs from 'tio-ui/components/nav-tabs';
import PageHero from 'tio-ui/components/page-hero';
import Card from 'tio-ui/components/card';
import { array } from '@ember/helper';
import type { TOC } from '@ember/component/template-only';
import { VStack } from 'tio-ui/components/layout';
import { PhHandCoins } from 'ember-phosphor-icons';

interface QuestionsLoanForgivenessSignature {
  Args: {
    incomeRoute: string;
    indexRoute: string;
    teacherRoute: string;
  };
  Blocks: {
    default: [];
  };
}

const QuestionsLoanForgivenessComponent: TOC<QuestionsLoanForgivenessSignature> = <template>
  <VStack>
    <PageHero
      @icon={{PhHandCoins}}
      @title={{t "pslf.questions.what_is_loan_forgiveness_q"}}
      @subtitle={{t "pslf.questions.what_is_loan_forgiveness_a"}}
    />

    <Card>
      <h2 class="tio-text-lg-semibold tio-fg-primary mb-3">
        {{t "pslf.questions.whats_the_catch.title"}}
      </h2>
      <div class="tio-col-loose sm:grid sm:grid-cols-3">
        <p class="tio-fg-secondary">{{t "pslf.questions.whats_the_catch.catch_1"}}</p>
        <p class="tio-fg-secondary">{{t "pslf.questions.whats_the_catch.catch_2"}}</p>
        <p class="tio-fg-secondary">{{t "pslf.questions.whats_the_catch.catch_3"}}</p>
      </div>
    </Card>

    <Card>
      <NavTabs
        @tabs={{array
          (hash label=(t "pslf.questions.public_service.tab_title") route=@indexRoute)
          (hash label=(t "pslf.questions.income_driven.tab_title") route=@incomeRoute)
          (hash label=(t "pslf.questions.teacher.tab_title") route=@teacherRoute)
        }}
      />
      {{yield}}
    </Card>
  </VStack>
</template>;

export default QuestionsLoanForgivenessComponent;
